export const getMonthsArray = (start: number, count: number): Array<number> => {
  return [...Array(count).keys()].map(index => (start + index) % 12);
};
